module.exports = __webpack_public_path__ + "img/referencia.6ea5435f.jpg";